const cnstrcPurchase = (purchaseData) => {
  if (__BROWSER__) {
    const eventObj = {
      items: purchaseData.items,
      order_id: purchaseData.orderId,
      revenue: purchaseData.revenue
    }

    window.cnstrcPurchaseData = eventObj
  }
}

const cnstrcUserLogin = (userId = "") => {
  if (__BROWSER__ && userId) {
    window.cnstrcUserId = userId
  }
}

const cnstrcUserLogout = () => {
  if (__BROWSER__ && window.cnstrcUserId) {
    delete window.cnstrcUserId
  }
}

const toExportEvents = {
  cnstrcPurchase,
  cnstrcUserLogin,
  cnstrcUserLogout
}

export default toExportEvents